<template>
  <div class="iBanner">
    <swiper
      :modules="modules"
      :slides-per-view="1"
      :space-between="50"
      :pagination="{ clickable: true }"
      :autoplay="{ delay: 5000 }"
      :navigation="true"
      :effect="'fade'"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
    >
      <swiper-slide v-for="pic in carousel" :key="pic">
        <span class="foreground">
          <span class="box">
            <span class="subject"><img src="@/assets/images/main_logo_1.png"></span>
            <span class="summary">2022/10/15<br>曜越單車旗艦館內，盛大展開！</span>
          </span>
        </span>
        <div class="iBanPic" :style="'background-image: url(' + pic.img + ')'">
          <video class="videoFull" preload="auto" autoplay loop playsinline muted="muted" volume="0" v-if="pic.video != ''">
            <source :src='pic.video' type="video/mp4">
          </video>
        </div>
      </swiper-slide>
      <!-- <swiper-slide><img src="@/assets/images/i_banner_1.jpg" alt="thermaltake"></swiper-slide> -->
      
    </swiper>
    <svg class="mountain" xmlns:xlink="http://www.w3.org/1999/xlink" style="transform:rotate(0deg); transition: 0.3s" viewBox="0 0 1440 110" version="1.1" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="sw-gradient-0" x1="0" x2="0" y1="1" y2="0"><stop stop-color="rgba(255, 255, 255, 1)" offset="0%"/><stop stop-color="rgba(221.168, 221.168, 221.168, 1)" offset="100%"/></linearGradient></defs><path style="transform:translate(0, 0px); opacity:1" fill="url(#sw-gradient-0)" d="M0,11L120,20.2C240,29,480,48,720,45.8C960,44,1200,22,1440,12.8C1680,4,1920,7,2160,22C2400,37,2640,62,2880,73.3C3120,84,3360,81,3600,71.5C3840,62,4080,48,4320,51.3C4560,55,4800,77,5040,80.7C5280,84,5520,70,5760,64.2C6000,59,6240,62,6480,64.2C6720,66,6960,66,7200,62.3C7440,59,7680,51,7920,55C8160,59,8400,73,8640,71.5C8880,70,9120,51,9360,47.7C9600,44,9840,55,10080,53.2C10320,51,10560,37,10800,38.5C11040,40,11280,59,11520,60.5C11760,62,12000,48,12240,40.3C12480,33,12720,33,12960,33C13200,33,13440,33,13680,34.8C13920,37,14160,40,14400,45.8C14640,51,14880,59,15120,60.5C15360,62,15600,59,15840,49.5C16080,40,16320,26,16560,31.2C16800,37,17040,62,17160,75.2L17280,88L17280,110L17160,110C17040,110,16800,110,16560,110C16320,110,16080,110,15840,110C15600,110,15360,110,15120,110C14880,110,14640,110,14400,110C14160,110,13920,110,13680,110C13440,110,13200,110,12960,110C12720,110,12480,110,12240,110C12000,110,11760,110,11520,110C11280,110,11040,110,10800,110C10560,110,10320,110,10080,110C9840,110,9600,110,9360,110C9120,110,8880,110,8640,110C8400,110,8160,110,7920,110C7680,110,7440,110,7200,110C6960,110,6720,110,6480,110C6240,110,6000,110,5760,110C5520,110,5280,110,5040,110C4800,110,4560,110,4320,110C4080,110,3840,110,3600,110C3360,110,3120,110,2880,110C2640,110,2400,110,2160,110C1920,110,1680,110,1440,110C1200,110,960,110,720,110C480,110,240,110,120,110L0,110Z"/><defs><linearGradient id="sw-gradient-1" x1="0" x2="0" y1="1" y2="0"><stop stop-color="rgba(255, 255, 255, 1)" offset="0%"/><stop stop-color="rgba(184.74, 184.74, 184.74, 1)" offset="100%"/></linearGradient></defs></svg>
  </div>
</template>

<style>
.mountain {
  position: absolute;
  bottom: -30px;
  left: 0;
  z-index: 1;
}
.iBanner {
  position: relative;
}
.videoFull {
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  top: 0;
  left: 0;
  z-index: 0;
  overflow: hidden;
  max-width: none;
}
.iBanner .swiper img {
  display: block;
}
.iBanner .swiper-horizontal>.swiper-pagination-bullets, .swiper-pagination-bullets.swiper-pagination-horizontal, .swiper-pagination-custom, .iBanner .swiper-pagination-fraction {
  bottom: 40px;
}
.iBanner .swiper-pagination-bullet-active {
  background: #b3a480;
  width: 25px !important;
}
.iBanner .swiper-pagination-bullet {
  width: 15px;
  height: 15px;
  border-radius: 99px;
  /* margin: 0 !important; */
  /* vertical-align: bottom; */
  -webkit-transition: .3s ease-in-out;
  -o-transition: .3s ease-in-out;
  transition: .3s ease-in-out;
}
/* 箭頭 */
.iBanner .swiper-button-prev, .iBanner .swiper-button-next {
  border-top: 1px solid #afafaf;
  border-right: 1px solid #afafaf;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  -webkit-transition: .3s ease-in-out;
  -o-transition: .3s ease-in-out;
  transition: .3s ease-in-out;
  margin-top: 20px;
  background-color: transparent !important;
  border-radius: 0 !important;
  width: 40px !important;
  height: 40px !important;
  box-shadow: none !important;
  position: absolute;
}
.iBanner .swiper-button-prev:after, .iBanner .swiper-button-next:after {
  content: none;
}
.iBanner .swiper-button-prev {
  left: 20px !important;
  top: 50%;
  margin: -10px 0 0;
  border-bottom: 1px solid #afafaf;
  border-left: 1px solid #afafaf;
  border-top: 0;
  border-right: 0;
}
.iBanner .swiper-button-next {
  right: 20px !important;
  top: 50%;
  margin: -10px 0 0
}

.iBanner .iBanPic {
  display: block;
  height: 100vh;
  background-position: center;
  background-size: cover;
}
.iBanner .swiper-slide {
  height: 100vh;
}

.foreground {
  display: none;
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 0 5%;
  top: 0;
  z-index: 1;
  /* visibility: hidden; */
}
.foreground .box {
  -webkit-transition: all 2s ease-in-out;
  -moz-transition: all 2s ease-in-out;
  -ms-transition: all 2s ease-in-out;
  -o-transition: all 2s ease-in-out;
  transition: all 2s ease-in-out;
  display: block;
  position: absolute;
  top: 50%;
  z-index: 10;
  width: 100%;
  max-width: 600px;
  text-align: left;
  -moz-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
}
.foreground .subject {
  display: block;
  font-size: 50px;
  letter-spacing: 10px;
  font-weight: 700;
  font-family: "Open Sans", "Myriad Pro", Myriad, Aria, sans-serif, 微軟正黑體;
  /* font-family: 'Playfair Display', serif; */
  /* font-family: 'Prata', serif; */
  text-transform: uppercase;
  /* background: linear-gradient(to top, #cbba89, #978a65); */
  background: linear-gradient(to top, #707070, #afafaf);
  background: -webkit-linear-gradient(to top, #707070, #afafaf);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
}
.foreground .summary {
  color: #FFF;
  text-shadow: 1px 1px 1px #000000;
  font-size: 30px;
  line-height: 40px;
  font-style: italic;
  font-weight: bold;
  padding: 20px 0 0 110px;
  text-align: left;
  display: block;
}
.summary {
  font-size: 16px;
  letter-spacing: .8px;
  line-height: 25px;
  font-weight: 300;
}
.foreground .btn {
  display: inline-block;
  border: 1px solid #707070;
  padding: 10px 100px;
  color: #707070;
  text-align: center;
  font-size: 15px;
  border-radius: 10px;
  margin-top: 20px;
  /* background-color: rgba(0, 0, 0, 0.1); */
}

/* 按鈕 */
.btn-wrap {
  margin-top: 50px;
  text-align: center;
}
.g-btn,.iActionBR .g-btn {
  position: relative;
    display: inline-block;
    width: 50%;
    /* height: 45px; */
    font-size: 25px;
    /* line-height: 45px; */
    text-align: center;
    white-space: nowrap;
    margin: 0;
    padding: 10px 20px;
    border-style: solid;
    border-width: 1px;
    font-weight: 600;
    box-shadow: none;
    border-color: transparent;
    /* background-color: transparent; */
    background-color: #ffffff1f;
    color: #ffffff;
    border: 1px solid #FFF;
}

@media only screen and (max-width: 767px) {
  .iBanner .iBanPic {
    height: 400px;
  }
  .iBanner .swiper-slide {
    height: 100%;
  }

  .foreground {
    position: static;
    padding: 100px 5% 50px;
    background-color: #ffffff;
    /* display: block; */
  }
  .foreground .box {
    display: block;
    position: static;
    max-width: none;
    transform: translate(0, 0);
  }
  .foreground .subject {
    font-size: 40px;
    /* height: 60px; */
    overflow: hidden;
  }
  .foreground .summary {
    height: 140px;
    overflow: hidden;
    padding: 20px 0 0;
    color: #252525;
    text-shadow: 1px 1px 1px #FFF;
    text-align: center;
  }
  .iBanner .swiper-button-prev, .iBanner .swiper-button-next {
    display: none;
  }
  .mountain {
    bottom: -20px;
  }
}
</style>

<script>
/* swiper */
// 安裝：npm i swiper
import { Navigation, Pagination, Scrollbar, A11y, Autoplay, EffectFade } from 'swiper'; // 要 Autoplay、EffectFade，要載入
import { Swiper, SwiperSlide } from 'swiper/vue';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/effect-fade';
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      carousel: [
        {
          img: `${require('@/assets/images/i_banner_1.jpg')}`,
          video: ``, // ${require('@/assets/images/training.mp4')}
          link: '/portfolioList',
          title: '曜越單車電競爭霸戰',
        },
        
      ],
    }
  },
  // inject: ['emitter'], // 內層元件用Inject的方式把emitter讀進來
  mounted() {
    
  },
  setup() {
    const onSwiper = (swiper) => {
      // console.log(swiper);
    };
    const onSlideChange = () => {
      // console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay, EffectFade], // 要 Autoplay、EffectFade，要載入
    };
  },
}
</script>